/* tslint:disable:completed-docs */
import {TRACKING} from 'Constant';

/**
 * Tracking Type for On Chat Events / User Interactions
 */
export const TRACKING_WEBCHAT_INTERACTION = 'chat interaction';

/**
 * Tracking Actions
 */
export const TRACKING_WEBCHAT_ACTION_START = 'start';
export const TRACKING_WEBCHAT_ACTION_HANDOVER = 'handover to agent';
export const TRACKING_WEBCHAT_ACTION_DISCONNECT = 'closed by user';

/**
 * Tracking misc
 */
export const TRACKING_WEBCHAT_TOOL = 'tobi';

/**
 * Tracking Variants
 */
export const TRACKING_WEBCHAT_VARIANT_OVERLAY = 'overlay';

/**
 * Tracking Type for Errors
 */
export const TRACKING_WEBCHAT_ERROR = 'error';

export const TRACKING_WEBCHAT_ERROR_TYPE = 'technical';
export const TRACKING_WEBCHAT_ERROR_LOCATION = 'tobi overlay';

/**
 * Errormessage for not available errorMessage
 */
export const TRACKING_WEBCHAT_ERROR_MESSAGE_NOT_AVAILBLE = 'n.a.';

/**
 * Tracking Actions
 */
export const TRACK_WEBCHAT_START = `webchat/${TRACKING}/TRACK_WEBCHAT_START`;
export const TRACK_WEBCHAT_FAILED = `webchat/${TRACKING}/TRACK_WEBCHAT_FAILED`;
export const TRACK_WEBCHAT_DISCONNECT = `webchat/${TRACKING}/TRACK_WEBCHAT_DISCONNECT`;
export const TRACK_WEBCHAT_AGENT_HANDOVER = `webchat/${TRACKING}/TRACK_WEBCHAT_AGENT_HANDOVER`;
